export default "__VITE_ASSET__DpBSne2P__"